<template>
  <nav>
    <router-link to="/admin">Home</router-link> |
    <!--<router-link to="/admin/about">About</router-link> |-->
    <router-link to="/admin/holidayList">휴일</router-link> |
    <router-link to="/admin/teacherList">선생님</router-link> |
    <router-link to="/admin/schoolList">어린이집</router-link> |
    <router-link to="/admin/scheduleList">스케줄</router-link> |
    <router-link to="/admin/classList">수업관리</router-link> |
    <router-link to="/admin/changeList">변경이력</router-link> |
    <router-link to="/admin/calList">캘린더</router-link> |
    <router-link to="/admin/invoiceList">거래명세서</router-link> |
    <router-link to="/admin/calcList">정산</router-link>
  </nav>
  <router-view/>
</template>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.v-select input{
  border:none;
}

</style>
